
import { addServiceHistory } from "../../../store/slices/vehicleSlice";

export default function responseaddServiceHistory(response: any, api: any, arg: any) {
    console.log("Service added successfully", response?.data);
    if (response?.data) {
        // The response contains the full vehicle object with updated history
        const vehicle = response.data;
        // Get the latest service entry (first one since history is sorted by createdAt descending)
        if (vehicle.history && vehicle.history.length > 0) {
            const latestService = vehicle.history[0];
            api.dispatch(addServiceHistory({
                id: vehicle._id,
                service: latestService
            }));
        }
    }
    return response?.data || null;
}